import React from 'react';
import {
  Box,
  Button,
  Icons,
  Typography,
  useTheme,
} from '@ublend-npm/aulaui-core';
import PublicOffIcon from '@mui/icons-material/PublicOff';
import { getStarredSpaceColors } from '../../colors';

export type WidgetErrorType = 'api' | 'offline';

type WidgetErrorStateProps = {
  type: WidgetErrorType;
  onRetry: () => void;
  isRetrying?: boolean;
};

const STRINGS = {
  apiMessage: "We couldn't load this information right now.",
  offlineMessage: 'Check your internet connection and try again.',
  retry: 'Retry',
};

const WidgetErrorState = ({
  type,
  onRetry,
  isRetrying = false,
}: WidgetErrorStateProps) => {
  const { palette } = useTheme();
  const colors = getStarredSpaceColors(palette);
  const isOffline = type === 'offline';

  return (
    <Box
      sx={{
        flex: 1,
        alignSelf: 'stretch',
        display: 'flex',
        width: '100%',
        minHeight: '100%',
      }}
    >
      <Box
        sx={{
          flex: 1,
          width: '100%',
          minHeight: '100%',
          bgcolor: colors.errorStateBg,
          borderRadius: '16px',
          p: '16px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
        }}
      >
        {isOffline ? (
          <PublicOffIcon
            sx={{
              fontSize: 24,
              color: palette.text.disabled,
              mb: 1.5,
            }}
            aria-hidden
          />
        ) : (
          <Icons.InfoOutlined
            sx={{
              fontSize: 24,
              color: palette.text.disabled,
              mb: 1.5,
            }}
            aria-hidden
          />
        )}

        <Typography variant="body2" color="text.secondary" maxWidth="100%">
          {isOffline ? STRINGS.offlineMessage : STRINGS.apiMessage}
        </Typography>

        <Button
          kind="primary"
          size="small"
          onClick={onRetry}
          disabled={isRetrying}
          sx={{ mt: 2, minWidth: 72 }}
        >
          {STRINGS.retry}
        </Button>
      </Box>
    </Box>
  );
};

export default WidgetErrorState;
